import _ from 'underscore';
import { mapState } from 'vuex';
import codepreivew from './preview/index.vue'


export default {
	name: 'promocodes_list',
	props: {
		scroll : Number
	},

	components : {
		codepreivew
	},

	data : function(){

		return {
			loading : false,
			searchvalue : '',
			count : 0,
			sort : 'date_desc',
			sorting : {

				date_asc : {
					text : 'date_asc',
					field : 'end',
					sort : 'asc'
				},
				date_desc : {
					text : 'date_desc',
					field : 'end',
					sort : 'desc'
				}
			},


		}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		}
	},
	computed: mapState({
		dheight: state => state.dheight,
		tscrolly : function(state){
			return this.scroll || state.tscrolly
		},
		auth : state => state.auth,
		userinfo : state => state.userinfo?.userinfo,

		payload : function(){

		
			return {
				searchStrFilter : this.searchvalue,
				sortFields : [{
					field : this.sorting[this.sort].field,
					order : this.sorting[this.sort].sort
				}]
			}
		},

		menu : function(){

			return []

		},

		

		grouppedResults : function(){

		},


		api : function(){

			if(this.userinfo.type == '4'){
				return 'payments.promo.list'
			}

			if(this.userinfo.type == '2' || this.userinfo.type == '8'){
				return 'team.promo.list'
			}
			

			return ''
			
		}
	}),

	methods : {

		reload : function(){
			if(this.$refs['list']) this.$refs['list'].reload()
		},

		search : function(v){
			this.searchvalue = v
		},

		setcount : function(v){
			this.count = v
		},

		sortchange : function(v){
			this.sort = v
		},

		article : function(){
			this.core.vueapi.articlestatic({
				module : 'strategy'
			})
		},

		addpromo : function(){

			this.core.vueapi.edit({
				index : 'id',
				ignoreerrors : false,
				request : 'payments.promo.addcode',

				schema : {
					fields : [
						{
							text : 'plans.promoFields.code',
							id : 'code',
							input : 'input',
							rules: [{
								message : 'fields.promocoderegex',
								rule : 'regex:^[a-zA-Z]*$'
							},{
								rule: 'required',
							},{
								message : 'fields.promocodemin6',
								rule : 'min:6'
							},{
								message : 'fields.promocodemax20',
								rule : 'max:20'
							}]
						},

						{
							text : 'plans.promoFields.start',
							input: 'date',
							id : 'start',
							rules: [{
								rule: 'date'
							}]
						},

						{
							text : 'plans.promoFields.discount',
							id : 'discount',
							input : 'input',
							type : 'number',
							rules: [{
								rule: 'required',
							},{
								message : 'fields.promodiscountmin5',
								rule : 'greater_than:5'
							},{
								message : 'fields.promodiscountmax14',
								rule : 'less_than:14'
							}]
						},

						{
							text : 'plans.promoFields.reward',
							id : 'reward',
							input : 'input',
							type : 'number',
							rules: [{
								message : 'fields.promorewardmin5',
								rule : 'greater_than:5'
							},{
								message : 'fields.promorewardmax14',
								rule : 'less_than:14'
							}]
						},

						{
							text : 'plans.promoFields.plan',
							id : 'planid',
							input : 'select',
							values : _.map(this.core.appInfo.plans, (p) => {
								return {
									value : p.id,
									text : this.$t('plans.' + p.name + '.name')
								}
							}),
							rules: [{
								rule: 'required',
							}]
						},

						{
							text : 'plans.promoFields.duration',
							id : 'duration',
							input : 'select',
							values : [{
								text : this.$t('plans.promoDuration.1w'),
								value : '1w'
							},{
								text : this.$t('plans.promoDuration.1m'),
								value : '1m'
							},{
								text : this.$t('plans.promoDuration.1y'),
								value : '1y'
							}],
							rules: [{
								rule: 'required',
							}]
						},

						
					]
				}
			}, {
				success : () => {
					this.$refs['list'].reload()
				}
			})

		}
	},
}